import { createContext, useContext } from "react";
export const QuiMenuContext = createContext({});
/** Can be used inside of a QuiMenu component subtree to control the menu */
export function useQuiMenu() {
    return useContext(QuiMenuContext);
}
